import React from 'react';
import Header from './components/Header/Header.js'
import Homepage from './components/Home/Home.js'
import Footer from './components/Footer/Footer.js'

import {Container, Row} from 'react-bootstrap';

function App() {
  return (
    <div className="App">
      <Container fluid>
        <Row>
          <Header />
          <Homepage />
          <Footer />
        </Row>
      </Container>
    </div>
  );
}

export default App;
